export function resolveGlobalSearchDom() {
    const modal = document.querySelector('[data-global-search-modal]');
    if (!(modal instanceof HTMLElement)) {
        return null;
    }

    const input = modal.querySelector('[data-global-search-input]');
    const clearButton = modal.querySelector('[data-global-search-clear]');
    const status = modal.querySelector('[data-global-search-status]');
    const results = modal.querySelector('[data-global-search-results]');
    const title = modal.querySelector('#global-search-title');
    const context = modal.querySelector('[data-global-search-context]');
    const dialog = modal.querySelector('[data-global-search-dialog]');

    if (
        !(input instanceof HTMLInputElement)
        || !(status instanceof HTMLElement)
        || !(results instanceof HTMLElement)
        || !(title instanceof HTMLElement)
        || !(dialog instanceof HTMLElement)
    ) {
        return null;
    }

    return {
        modal,
        input,
        clearButton,
        status,
        results,
        title,
        context,
        dialog,
        closeButtons: modal.querySelectorAll('[data-global-search-close]'),
    };
}
